import React from 'react';
import { useHistory } from 'react-router-dom';

const CartEmptyState = ({ type = 'cart', activeTab = null }) => {
  const history = useHistory();
  
  // There are three types of empty states:
  // 1. 'cart' - When the entire cart is empty
  // 2. 'tab' - When a specific tab is empty
  // 3. 'login' - When user is not logged in
  
  if (type === 'login') {
    return (
      <div className='min-h-screen flex flex-col gradient_limeade items-center justify-center bg-cover bg-center text-center'>
        <h2 className='text-2xl font-bold text-white mb-4'>
          You Should Login First
        </h2>
        <button 
          onClick={() => history.push('/login')}
          className='px-6 py-2 bg-brand-teal text-white rounded-md hover:bg-brand-teal-dark transition-colors'
        >
          Login
        </button>
      </div>
    );
  }
  
  if (type === 'cart') {
    return (
      <div className='min-h-screen flex flex-col gradient_limeade items-center justify-center bg-cover bg-center text-center'>
        <h2 className='text-2xl text-white font-bold mb-4'>
          You Don't Have Anything in Your Cart
        </h2>
        <button 
          onClick={() => history.push('/browse')}
          className='px-6 py-2 bg-brand-teal text-white rounded-md hover:bg-brand-teal-dark transition-colors'
        >
          Start Shopping
        </button>
      </div>
    );
  }
  
  // For empty tab
  return (
    <div className='min-h-[50vh] flex flex-col items-center justify-center text-center'>
      <h3 className='text-xl font-medium mb-4'>
        You Don't Have Anything to {activeTab}
      </h3>
      <button 
        onClick={() => history.push('/browse')}
        className='px-6 py-2 bg-brand-teal text-white rounded-md hover:bg-brand-teal-dark transition-colors'
      >
        Start Shopping
      </button>
    </div>
  );
};

export default CartEmptyState; 